import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPptIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18.305,
	height: 22.02,
	viewBox: "0 0 18.305 22.02",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "ppt-icon",
		transform: "translate(-229 -431)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "icon-back",
			transform: "translate(229 431)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "back-shape",
					d: "M31.276,1.685H21.5a1.282,1.282,0,0,0-1.282,1.282V22.423A1.282,1.282,0,0,0,21.5,23.7H35.41a1.282,1.282,0,0,0,1.282-1.282V7.1Z",
					transform: "translate(-18.387 -1.685)",
					fill: "#f7f6f8"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "corner-shadow",
					d: "M160.554,61.4h3.74v3.74Z",
					transform: "translate(-145.99 -55.98)",
					fill: "#eae9ec"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "corner",
					d: "M142.07,1.685V5.82a1.3,1.3,0,0,0,1.3,1.282h4.117Z",
					transform: "translate(-129.182 -1.685)",
					fill: "#d7d6db"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "block_shadow",
					"data-name": "block shadow",
					d: "M34.917,129.774v-7.125a.58.58,0,0,0-.58-.58H20.221v8.285H34.337a.58.58,0,0,0,.58-.58",
					transform: "translate(-18.387 -111.149)",
					fill: "#dee2e6"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "color_block",
					"data-name": "color block",
					d: "M15.95,125.635H.58a.649.649,0,0,1-.58-.7v-8.6a.649.649,0,0,1,.58-.7H15.95a.649.649,0,0,1,.58.7v8.6a.649.649,0,0,1-.58.7",
					transform: "translate(0 -107.299)",
					fill: "#e3370a"
				})
			]
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_3134",
			"data-name": "Path 3134",
			d: "M-5.884,0h.616c.2,0,.28-.084.28-.287V-1.54h.63c1.414,0,2.149-.616,2.149-1.806S-2.95-5.152-4.358-5.152H-5.884c-.2,0-.28.084-.28.287V-.287C-6.163-.084-6.079,0-5.884,0Zm.9-2.562V-4.13h.651c.6,0,.9.273.9.784s-.3.784-.9.784ZM-1.151,0h.616c.2,0,.28-.084.28-.287V-1.54h.63c1.414,0,2.149-.616,2.149-1.806S1.782-5.152.375-5.152H-1.151c-.2,0-.28.084-.28.287V-.287C-1.431-.084-1.347,0-1.151,0Zm.9-2.562V-4.13H.4c.6,0,.9.273.9.784s-.3.784-.9.784ZM4.372,0h.616c.2,0,.287-.084.287-.287V-4.081H6.346c.2,0,.28-.084.28-.287v-.5c0-.2-.084-.287-.28-.287H3.014c-.2,0-.28.084-.28.287v.5c0,.2.084.287.28.287H4.085V-.287C4.085-.084,4.176,0,4.372,0Z",
			transform: "translate(237.244 446.952)",
			fill: "#fff"
		})]
	})
});
export default SvgPptIcon;
